export const CHAT_TYPING_DESTINATION = "/app/chat.typing";
export const CHAT_READ_DESTINATION = "/app/chat.read";
export const CHAT_DELIVERED_DESTINATION = "/app/chat.delivered";

export const chatTypingTopic = (roomId) =>
  `/topic/chat/${roomId}/typing`;

export const chatReadTopic = (roomId) =>
  `/topic/chat/${roomId}/read`;

export const chatDeliveryTopic = (roomId) =>
  `/topic/chat/${roomId}/delivery`;

export const chatPresenceTopic = (userId) =>
  `/topic/presence/${userId}`;
